import React from "react";
import CertificateCSS from "../../../style/helperCSS/Certificate.module.css";

const Certificate = (props) => {
  return (
    <div className={`row ${CertificateCSS.certificate_row}`}>
      {props.certificates.map((e) => (
        <div
          className={`col-md-6 col-lg-4 ${CertificateCSS.certificate_column}`}
        >
          <div className={` ${CertificateCSS.certifcate_div}`} key={e.id}>
            <a
              className={`${CertificateCSS.img_div}`}
              href={e.certificate_url}
              target="_blank"
            >
              <img src={e.img_src} alt="Certificate Image" />
            </a>
            <div className={`${CertificateCSS.certifate_div}`}>
              <h5>{e.certificate_title}</h5>
              <p className={`${CertificateCSS.platform}`}>{e.platform}</p>
              <p className={`${CertificateCSS.view_certificate}`}>
                <a href={e.certificate_url} target="_blank" className="pink">
                  View Certificate
                </a>
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Certificate;
